import React from 'react';
import propTypes from 'prop-types';
import loading from '../../assets/lottie_report.json';
import Lottie from "lottie-react";
import { GET } from '../../utils/HttpClient';
import { Toast } from '../../utils/Toast';
import { Modal, Space } from 'antd';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import ColorButton from './ColorButton';
import { GREEN, RED_COLOR } from '../../constance/color';

export default function ReportExportButton(props) {
  const [showModal, setShowModal] = React.useState(false)
  const [blobData, setBlobData] = React.useState(null)

  React.useEffect(() => {
    if (showModal && blobData != null) {
      window.open(URL.createObjectURL(blobData));
      setShowModal(false);
      setBlobData(null);
    }
  }, [blobData])

  const generateReport = async () => {
    if (showModal) {
      return;  // Do nothing if modal already displayed
    }
    else if (props.url == null) {
      Toast.error("No url parameter")
      return;
    }

    setShowModal(true)
    try {
      props.onStarted()
      const response = await GET(props.url, props.params, false, true) // Download as blob
      setBlobData(response.data)
    } catch (error) {
      setShowModal(false);
      Toast.error(`Error exporting : ${error.errorMessages}`)
    } finally {
      props.onFinished()
    }
  }

  return (
    <>
      <Space>
        <ColorButton
          variant={props.variant ? props.variant : 'solid'}
          color='primary'
          override={props.color ? props.color : props.type === "excel" ? GREEN : RED_COLOR}
          onClick={generateReport}
          size={props.size}
          style={{ marginInline: '3px' }}
          disabled={props.disabled}
          icon={props.icon ? props.icon : props.type === "excel" ? <FileExcelOutlined /> : <FilePdfOutlined />}
        > {props.content ? props.content : props.type === "excel" ? 'Excel' : 'PDF'}
        </ColorButton>
      </Space>

      <Modal
        onCancel={() => setShowModal(false)}
        open={showModal}
        title={props.title}
        footer={null}
        closable={false}
      >
        <Lottie animationData={loading} loop={true} />
      </Modal>
    </>


  )
}

ReportExportButton.defaultProps = {
  url: "",
  type: "", // excel or pdf
  params: {},
  title: "",
  size: "mini",
  basic: false,
  content: null,
  color: null,
  icon: null,
  disabled: false,
  variant: "",
  onStarted: () => null,
  onFinished: () => null,  // notify when printing finished
}

ReportExportButton.propTypes = {
  url: propTypes.string,
  type: propTypes.string, // excel or pdf
  params: propTypes.object,
  title: propTypes.string,
  size: propTypes.string,
  basic: propTypes.bool,
  content: propTypes.string,
  color: propTypes.string,
  icon: propTypes.string,
  variant: propTypes.string,
  disabled: propTypes.bool,
  onStarted: propTypes.func,
  onFinished: propTypes.func,
}
